export enum EBloodType {
  A = 1,
  B = 2,
  AB = 3,
  O = 4,
  Unknown = 5,
}

export const EBloodTypeLabel = {
  [EBloodType.A]: 'A',
  [EBloodType.B]: 'B',
  [EBloodType.AB]: 'AB',
  [EBloodType.O]: 'O',
  [EBloodType.Unknown]: 'Tidak Diketahui',
};

export enum ERhesusType {
  Positive = 1,
  Negative = 2,
  Unknown = 3,
}

export const ERhesusTypeLabel = {
  [ERhesusType.Positive]: 'Positif',
  [ERhesusType.Negative]: 'Negatif',
  [ERhesusType.Unknown]: 'Tidak Diketahui',
};
